import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

import { ModalButtonResponseEnum } from '../../../enum/modal-button-response.enum';
import { BaseModalComponent } from '../../../models/base-modal.component.model';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit, BaseModalComponent {
  public title: string;
  public cancelText: string;
  public okText: string;
  public message: string;
  public routerLink?: string;
  public action = new Subject<ModalButtonResponseEnum>();
  public classBtnOk: string;

  constructor(
    public bsModalRef: BsModalRef,
    private router: Router,
    private readonly translate: TranslateService
  ) {}

  ngOnInit() {
    this.okText = this.okText || this.translate.instant('OK');
    this.cancelText = this.cancelText || this.translate.instant('Cancel');
  }

  confirm(): void {
    this.action.next(ModalButtonResponseEnum.OK);
    this.bsModalRef.hide();

    if (this.routerLink) {
      this.router.navigateByUrl(this.routerLink);
    }
  }

  decline(): void {
    this.action.next(ModalButtonResponseEnum.CANCEL);
    this.bsModalRef.hide();
  }

  hide(): void {
    this.bsModalRef.hide();
  }
}
